import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';
import { getContext, setContext } from 'svelte';
import { StoreKeys } from './StoresKeys';

export type ConfiguratorSummaryStore = {
    consumption?: {
        household: {
            consumption: number; // verbrauch
            selfSufficiency: number; // autarkie
            evQuote: number; // ev quote
            ev: number; // ev
        };
        heatPump: {
            consumption: number; // verbrauch
            selfSufficiency: number; // autarkie
            evQuote: number; // ev quote
            ev: number; // ev
        };
        eCar: {
            consumption: number; // verbrauch
            selfSufficiency: number; // autarkie
            evQuote: number; // ev quote
            ev: number; // ev
        };
        total: {
            consumption: number; // verbrauch
            selfSufficiency: number; // autarkie
            evQuote: number; // ev quote
            ev: number; // ev
        };
    },
    yield?: {
        specificYield: number;
        storageSize: number;
        pvYield: number;
    },
    economy?: {
        refundRate: number;
        yearlyRefund: number;
        yearlySavings: number;
        totalGain: number;
        totalCost: number;
        roi: number;
        averageElectricityPrice: number;
        totalElectricityCost: number;
        amortizationPeriod: number;
        energyGenerationCost: number;
    }
}

const configuratorSummaryStore = writable<ConfiguratorSummaryStore>({
    consumption: {
        household: {
            consumption: 0,
            selfSufficiency: 0,
            evQuote: 0,
            ev: 0
        },
        heatPump: {
            consumption: 0,
            selfSufficiency: 0,
            evQuote: 0,
            ev: 0
        },
        eCar: {
            consumption: 0,
            selfSufficiency: 0,
            evQuote: 0,
            ev: 0
        },
        total: {
            consumption: 0,
            selfSufficiency: 0,
            evQuote: 0,
            ev: 0
        }
    },
    yield: {
        specificYield: 0,
        storageSize: 0,
        pvYield: 0
    },
    economy: {
        refundRate: 0,
        yearlyRefund: 0,
        yearlySavings: 0,
        totalGain: 0,
        totalCost: 0,
        roi: 0,
        averageElectricityPrice: 0,
        totalElectricityCost: 0,
        amortizationPeriod: 0,
        energyGenerationCost: 0
    }
});

export const useConfiguratorSummaryStore = (initialValues?: ConfiguratorSummaryStore) => {
    if (initialValues) {
        configuratorSummaryStore.set(initialValues);
    }

    const setConfiguratorSummaryStore = () => {
        setContext(StoreKeys.CONFIGURATOR_SUMMARY, configuratorSummaryStore);
    };

    return {
        setConfiguratorSummaryStore,
        ...configuratorSummaryStore
    };
};

export const getConfiguratorSummaryStore = (): Writable<ConfiguratorSummaryStore> => {
    return getContext(StoreKeys.CONFIGURATOR_SUMMARY);
};

